import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import { HideCheckboxOptions } from '../../assets/data/hideCheckboxOnCondition'
import { isEmpty, isString } from '../../helper/index'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import {facilityMapping} from '../../assets/data/facilityOU'
import _ from 'lodash';
import {
    Button,
    ButtonStrip,
    InputFieldFF,
    SingleSelectFieldFF,
    ReactFinalForm,
    SwitchFieldFF,
    hasValue,
    TextAreaFieldFF,
    composeValidators,
    dhis2Username,
    FieldGroupFF,
    CheckboxFieldFF,
    FileInputFieldFF
} from '@dhis2/ui';
import moment from "moment";
import { TextField } from '@material-ui/core';
import {
    Checkboxes,
    Radios,

    TimePicker,
    Switches,
    KeyboardDatePicker,
    DatePicker,
    DateTimePicker,
    Autocomplete,

} from 'mui-rff';

import OUFieldConfig from './OUFieldConfig';

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';


import { apiServices } from '../../services/apiServices';
import HideShowCondition from '../validation/HideShowConditionRegistration'
import AssignCondition from '../validation/AssignRegistration'
import ShowErrorRegistration from '../validation/showError/ShowErrorRegistration'

import Validator from '../validation/validator/Validator'

import Grid from '@material-ui/core/Grid';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import Geocode from "react-geocode";
import OUMapping  from '../../assets/data/registerOU'

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import FormLabel from '@material-ui/core/FormLabel';

import { Checkbox as MuiCheckbox } from '@material-ui/core';

import SearchLocationInput from './SearchLocationInput'

import imgUrl from '../../assets/images/imageUrl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faTimes, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import QrReader from 'react-qr-reader'
import OfflineDb from '../../db'
import { ta } from 'date-fns/locale';
import { withTranslation, Trans , useTranslation } from 'react-i18next';
import swal from "sweetalert";
//import { Configuration } from '../../assets/data/config'
const { Form, Field, FormSpy } = ReactFinalForm




const ValidatorComponent = (fieldId, attribute, values, form, rules, field) => {

    let programRules = rules.programRule
    let programRulesVariables = rules.programRuleVariable

    let filteringRuleWithField = null
    let Flag = null
    let val = null
    let conditionArray = []
    let programRuleActionType = null
    let hideShow = true
    let assign
    programRules.map(rules => {
        filteringRuleWithField = rules.programRuleActions.filter(obj => obj.trackedEntityAttribute ? fieldId == obj.trackedEntityAttribute.id : undefined)

        if (filteringRuleWithField.length > 0) {


            switch (filteringRuleWithField[0].programRuleActionType) {
                case 'HIDEFIELD':
                    hideShow = HideShowCondition(rules, programRulesVariables, values, field)
                    break;

                case 'ASSIGN':
                    assign = AssignCondition(
                        rules,
                        programRulesVariables,
                        values,
                        field,
                        fieldId,
                        attribute,
                        filteringRuleWithField

                    );
                    // <AssignCondition fieldId={fieldId} rules={rules} programRulesVariables={programRulesVariables} values={values} field={field} filteringRuleWithField={filteringRuleWithField}/>
                    break;

                // case 'SHOWERROR':

                //     programRuleActionType = ShowErrorRegistration(rules, programRulesVariables, values, field, fieldId, attribute)
                // break;
            }

        }
    })

    return ({
        'hideShow': hideShow,
        'assign': assign
    })

};

const getTranslatedLabels = (attribute) => {
    if (localStorage.getItem("locale") == "en") {
        return attribute.displayName;
    } else if (attribute.translations && attribute.translations.length > 0) {
        //debugger;
        let label = attribute.translations.filter(tanslation => tanslation.property == "NAME" && tanslation.locale == localStorage.getItem("locale"))
        if (label.length > 0) {
            return label[0].value;
        } else {
            return attribute.displayName;
        }
    }
    return attribute.displayName;
};

function InputFieldConfig(props) {
    //console.log("props",props)
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let programData = props.programData
    let customfieldobj = props.customfieldobj,
    activeCaseDetails = props.activeCaseDetails,
    linkContactFlag = props.linkContactFlag,
    values = props.values,
    Configuration = props.Configuration;
    const {t} = useTranslation()
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [fieldType, setFieldType] = useState(null)
    const [optionSet, setOptions] = useState(null)
    const [icons, setIcons] = useState(null)
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [hideFieldAttr, setHideFieldAttr] = useState(false)
    //=========custom logic for UNDP==================
    const [PresentlyOnAntiTBMedicationId, setPresentlyOnAntiTBMedicationId] = useState(null)
    const [clientTypeID, setClientTypeID] = useState(null)
    const [verifiedFieldId, setVerifiedFieldId] = useState(null)
    function getCustomVariableIds(){
        programData.programTrackedEntityAttributes.map(regField => {
            if(regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "client type"){
                setClientTypeID(regField.trackedEntityAttribute.id)
            }
            if(regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "presently on anti-tb medication?"){
                setPresentlyOnAntiTBMedicationId(regField.trackedEntityAttribute.id)
            }
            if(regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "documents verified"){
                setVerifiedFieldId(regField.trackedEntityAttribute.id)
            }
        })
        if(fieldData.trackedEntityAttribute.attributeValues && fieldData.trackedEntityAttribute.attributeValues.length > 0){
            fieldData.trackedEntityAttribute.attributeValues.map((val) => {
                if (val.attribute.displayName === "hideField" && val.value == "true") {
                    setHideFieldAttr(true)
                }
            })
        }
    }
    const setClientTypeDropdwonValues = ()=>{
        
        if(activeCaseDetails && activeCaseDetails.data && values[clientTypeID] && values[PresentlyOnAntiTBMedicationId] == 'YES' && values[verifiedFieldId] == 'Yes'){
            values[clientTypeID] = Configuration.ltbiLinkVariables.index;
        }else if(values[PresentlyOnAntiTBMedicationId] != undefined && values[PresentlyOnAntiTBMedicationId] == 'YES' && values[verifiedFieldId] == 'Yes'){
            values[clientTypeID] = Configuration.ltbiLinkVariables.index
        }else if(linkContactFlag && linkContactFlag.data && linkContactFlag.data.enabled){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }/*else if(activeCaseDetails && activeCaseDetails.data && values[PresentlyOnAntiTBMedicationId] == 'NO' && values[clientTypeID] == Configuration.ltbiLinkVariables.contact){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }else if(activeCaseDetails && activeCaseDetails.data && values[PresentlyOnAntiTBMedicationId] == 'NO' && values[clientTypeID] == Configuration.ltbiLinkVariables.presumptivetb){
            values[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
        }
        else if(activeCaseDetails && activeCaseDetails.data && values[PresentlyOnAntiTBMedicationId] == undefined){
            //use default values coming for edit
        }*/
        else if(activeCaseDetails && activeCaseDetails.data && values[verifiedFieldId] == 'No' && values[clientTypeID] == Configuration.ltbiLinkVariables.contact){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }else if(activeCaseDetails && activeCaseDetails.data && values[verifiedFieldId] == 'No' && values[clientTypeID] == Configuration.ltbiLinkVariables.presumptivetb){
            values[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
        }else if(values[verifiedFieldId] == 'No' && values[clientTypeID] != Configuration.ltbiLinkVariables.contact){
            values[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
        }
        else if(activeCaseDetails && activeCaseDetails.data && values[verifiedFieldId] == undefined){
            //use default values coming for edit
        }
    }
    //End
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const scriptCheck = value => (value && value != undefined && value != null && value != '' ? value.match(/<[^>]*>/g) != null ? t('Incorrect expression "< or >" added as input') : undefined : undefined)
    const numberCheck = value => (value ? value.match(/\d+/g) != null ? t('Alphanumeric not allowed!') : undefined : undefined)
    const requiredOptions = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Please fill out this field') : undefined)
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    function checkHideOptionsFields(attributes, programRules, programRulesVariables, values) {
        const fieldId = attributes.trackedEntityAttribute.id;
        let option = [];
        let filteringRuleWithField = null;

        programRules.map((rules) => {
            filteringRuleWithField = rules.programRuleActions.filter((obj) =>
                obj.trackedEntityAttribute ? fieldId == obj.trackedEntityAttribute.id : undefined
            );

            if (
                filteringRuleWithField.length > 0 &&
                filteringRuleWithField[0].programRuleActionType == "HIDEOPTION"
            ) {
                const operators = ["==", "!="];
                const condition = rules.condition;
                const splitConditions = condition.split("&&");
                let Flag = null;
                let val = null;
                let conditionArray = [];
                splitConditions.map((splitCondition) => {
                    const variableName = splitCondition.match(/\{(.*?)\}/)[1];
                    const parentRaw = programRulesVariables.filter(
                        (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
                    ); //[0] .dataElement.id
                    const parentNameFromFilter =
                        parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
                    const parentId =
                        parentRaw.length > 0
                            ? parentRaw[0].dataElement
                                ? parentRaw[0].dataElement.id
                                : parentRaw[0].trackedEntityAttribute
                                    ? parentRaw[0].trackedEntityAttribute.id
                                    : undefined
                            : undefined;

                    const parentNameFromFilterStart = splitCondition.search(
                        parentNameFromFilter
                    );
                    const parentNameLength = parentNameFromFilter
                        ? parentNameFromFilter.length
                        : undefined;

                    const operatorInitLength =
                        parentNameFromFilterStart + parentNameLength + 2;

                    const operator = splitCondition.substring(
                        operatorInitLength,
                        operatorInitLength + 2
                    );

                    const alternateOperatorFinding = operators.map((ops) => {
                        if (splitCondition.search(ops) > -1) {
                            const a = {
                                operator: ops,
                                operatorLength: splitCondition.search(ops),
                            };
                            return a;
                        }
                    });
                    const stringLength = splitCondition.length;
                    if (parentNameFromFilter) {
                        const filteredOperator = alternateOperatorFinding.filter(
                            (obj) => obj != undefined
                        );

                        const conditionValueRaw =
                            filteredOperator.length > 0
                                ? splitCondition.substring(
                                    filteredOperator[0].operatorLength + 3,
                                    splitCondition.length
                                )
                                : undefined;

                        const removeEmptySpace =
                            conditionValueRaw != undefined
                                ? conditionValueRaw.substring(
                                    conditionValueRaw.length - 1,
                                    conditionValueRaw.length
                                ) == " "
                                    ? conditionValueRaw.substring(0, conditionValueRaw.length - 1)
                                    : conditionValueRaw
                                : undefined;

                        const conditionValue =
                            removeEmptySpace != undefined
                                ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                                : undefined;
                        const conditionalOperator =
                            filteredOperator.length > 0
                                ? filteredOperator[0].operator
                                : undefined;
                        let conditionForValidation = null;
                        if (conditionalOperator != undefined) {
                            val = conditionValue;
                            switch (conditionalOperator) {
                                case "==":
                                    if (
                                        values[parentId] != undefined &&
                                        String(values[parentId]) == String(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        if (option.length > 0) {
                                                            let checkOptionInArray = option.find(obj => obj.id == options.id)
                                                            if(checkOptionInArray == undefined) {
                                                                option.push(options);
                                                            }
                                                    
                                                        } else {
                                                            option.push(options);
                                                        }
                                                        
                                                        
                                                        
                                                    } else {
                                                        // values[fieldId] = ''
                                                    
                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                    
                                                        let checkOptionInArray = option.find(obj => obj.id == temp.id)
                                                    
                                                        if(checkOptionInArray == undefined) {
                                                            option.push(temp);
                                                        }
                                                        
                                                        
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) >= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) <= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) < Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) > Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;
                            }
                        } else {
                            // values[parentId] != ''
                            // values[fieldId] = ''
                        }
                    }
                });
            }
        });
        if (option.length > 0) {
            return option;
        } else {
            return attributes.trackedEntityAttribute.optionSet.options
        }
    }

    function findFieldType() {
        const trackedEntityAttribute = fieldData.trackedEntityAttribute
        if (trackedEntityAttribute.optionSet != undefined) {
            if (fieldData.renderOptionsAsRadio) {
                setFieldType('radio')
            } else {
                if (fieldData.renderType) {
                    if (fieldData.renderType.DESKTOP) {
                        if (fieldData.renderType.DESKTOP.type == "ICONS_AS_BUTTONS") {
                            setFieldType('radio')
                        } else {
                            setFieldType('dropdown')
                        }
                    }
                }
            }
        } else {
            setFieldType('text')
        }
    }

    function fetchOption() {
        let output = []
        const trackedEntityAttribute = fieldData.trackedEntityAttribute
        
        if (trackedEntityAttribute.optionSet != undefined) {
            let refinedOptionList = checkHideOptionsFields(fieldData, programRules, programRulesVariables, values);
            
            //dataElement.optionSet.options.map((items, index) => {
            refinedOptionList.map((items, index) => {    
                if(items && items.code == "None"){
                    items.displayName = null;
                }
                if (icons.length > 0) {
                    output.push({ 'value': items.code, 'label': <> <span dangerouslySetInnerHTML={{ __html: icons[index] }} /> <>{getTranslatedLabels(items)} </>  </> })
                } else {
                    output.push({ 'value': items.code, 'label': getTranslatedLabels(items) })
                }
            })

        }
        if (output.length > 0) {
            setOptions(output)
        }
    }

    function getIcons() {
        let promises = [];
        const trackedEntityAttribute = fieldData.trackedEntityAttribute
        if(navigator.onLine){
            if (trackedEntityAttribute.optionSet != undefined) {
                trackedEntityAttribute.optionSet.options.forEach((options) => {
                    if (options.style != undefined && Object.keys(options.style).length > 0) {
    
                        const getIconApi = 'icons/' + options.style.icon + '/icon.svg'
                        promises.push(apiServices.getAPI(getIconApi))
                    } else {
                        promises.push({})
                    }
                })
    
                Promise.all(promises).then((responses) => {
    
                    const icons = responses.map((response) => response.data)
    
                    if (icons.length > 0) {
                        setIcons(icons)
                    } else {
                        setIcons([])
                    }
                })
            } else {
                setIcons([])
            }
        }else{
            setIcons([])
        }
        

    }

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }
    
    useEffect(() => {
        getIcons()
        getCustomVariableIds()
    }, [])
    useEffect(() => {
        if(clientTypeID != null){
            setClientTypeDropdwonValues()
        }
    })
    useEffect(() => {
        if (Array.isArray(icons)) {
            findFieldType()
            fetchOption()
            fetchValidation()
        }

    }, [icons,values,localStorage.getItem("locale")])

    useEffect(() => {
        
        if (validationResult != null && fieldType != null) {
            let dobUID = 'jlimFMRVTtJ'
            if(fieldData.trackedEntityAttribute.displayName == "Father's Last Name" || fieldData.trackedEntityAttribute.displayName == "Mother's Last Name" || fieldData.trackedEntityAttribute.displayName == "Gender" || fieldData.trackedEntityAttribute.displayName == "Key population"){
                fieldData.mandatory = true;
                if(fieldData.trackedEntityAttribute.displayName == "Key population"){
                    //hide none
                    if(values[fieldData.trackedEntityAttribute.id] && values[fieldData.trackedEntityAttribute.id] == "None"){
                        values[fieldData.trackedEntityAttribute.id] = ''
                    }
                }
            }
            if(fieldData.trackedEntityAttribute.displayName == 'Year of birth with DD/MM'){
                dobUID = fieldData.trackedEntityAttribute.id
                values[dobUID] = values["dHDHVYFgokt"] ? '01/01/'+values["dHDHVYFgokt"] : '01/01/'
                validationResult.hideShow = false
            }
            if(fieldData.trackedEntityAttribute.displayName == "isOffline"){
                if(!navigator.onLine){
                    values[fieldData.trackedEntityAttribute.id] = "true";
                }
            }
            if (fieldType == "text") {
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true && !hideFieldAttr ? '' : 'hide'}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            validate={fieldData.trackedEntityAttribute.displayName == 'Year of birth with DD/MM' ? composeValidators(required) : composeValidators(required, scriptCheck,numberCheck)} //fieldData.mandatory && validationResult.hideShow == true ? hasValue : false
                            value=''
                        />
                    </Grid>
                )
            } else if (fieldType == "radio") {
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        <Radios
                            id={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            name={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            data={optionSet != null ? optionSet : []}
                            validate={composeValidators(requiredOptions)}
                        // defaultValue={defaultValue}
                        />
                    </Grid>
                )

            } else if (fieldType == "dropdown") {
                if(fieldData.trackedEntityAttribute.displayName && fieldData.trackedEntityAttribute.displayName.toLowerCase() == "year of birth"){
                    if(values && values[fieldData.trackedEntityAttribute.id]){
                        if(values[fieldData.trackedEntityAttribute.id] >= 1900 && values[fieldData.trackedEntityAttribute.id] < 1960){
                            values[fieldData.trackedEntityAttribute.id] = "1960"
                        }
                    }
                }
                if(validationResult.hideShow == true) {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4} >
                            <Field
                                id={fieldData.trackedEntityAttribute.id}
                                name={fieldData.trackedEntityAttribute.id}
                                label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                                // type={fieldData.trackedEntityAttribute.valueType}
    
                                component={SingleSelectFieldFF}
                                key={fieldData.trackedEntityAttribute.id}
                                //validate= {fieldData.mandatory && validationResult.hideShow == true ? hasValue: false}
                                validate={requiredOptions}
                                required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                                options={optionSet != null ? optionSet : []}
                                disabled={fieldData.trackedEntityAttribute.attributeValues && fieldData.trackedEntityAttribute.attributeValues.length > 0 ? fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                                //onChange={() => onDropdownOptionChange}
                            />
                        </Grid>
                    )
                }  else {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4} className={'hide'}>
                            <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            options={optionSet != null ? optionSet : []}
                            disabled={fieldData.trackedEntityAttribute.attributeValues && fieldData.trackedEntityAttribute.attributeValues.length > 0 ? fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                            //onChange={() => onDropdownOptionChange}
                            validate={composeValidators(required, scriptCheck)} //fieldData.mandatory && validationResult.hideShow == true ? hasValue : false
                            value=''
                        />
                        </Grid>
                    )
                } 
                
            }
        }


    }, [fieldType, optionSet, validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DateFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let showYear = fieldData.trackedEntityAttribute.attributeValues.length > 0 && fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(null);//useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            console.log("values ",values);
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <DatePicker

                        //disabled={showYear ? true : false}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        name={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        value={values[fieldData.trackedEntityAttribute.id] == undefined ? null : values[fieldData.trackedEntityAttribute.id]}
                        margin="normal"
                        variant="inline"
                        format={showYear == true ? "yyyy" : "yyyy-MM-dd"}
                        views={["year"]}
                        validate={selectedDate && selectedDate.mandatory && validationResult.hideShow == true ? hasValue : false}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function DateTimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let showYear = fieldData.trackedEntityAttribute.attributeValues.length > 0 && fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <DateTimePicker
                        disabled={showYear ? true : false}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        name={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        value={values[fieldData.trackedEntityAttribute.id] == undefined ? selectedDate : values[fieldData.trackedEntityAttribute.id]}
                        margin="normal"
                        variant="inline"
                        format={showYear == true ? "yyyy" : "yyyy-MM-dd"}
                        validate={selectedDate.mandatory && validationResult.hideShow == true ? hasValue : false}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function AgeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    const {t} = useTranslation()
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? t('Must be a number') : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : t('Should be greater than')+min
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type="number"
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber)}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function PhoneNumberFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let locale = localStorage.getItem('locale')
    const {t} = useTranslation()
    const numberFormat = value =>
        isNaN(value) && value ? t(`Incorrect format`) : undefined
    //`Should be less than ${max}`
    const maxLength = max => value => value ? isNaN(value) || value.length > max ? locale == 'en' ? t('Should be less than') + max : t('Should be less than') : undefined : undefined
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, numberFormat, maxLength(11))}
                        className={"phone-number-block"}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function EmailFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const EMAIL_ADDRESS_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

    const invalidEmailMessage = 'Please provide a valid email address'

    const email = value =>
        isEmpty(value) || (isString(value) && EMAIL_ADDRESS_PATTERN.test(value))
            ? undefined
            : invalidEmailMessage

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'email'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={email}

                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DefaultValueField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let linkContactFlag= props.linkContactFlag
    let OUJSON = props.OUJSON
    let activeCaseDetails = props.activeCaseDetails
    //console.log("OUJSON",props,props.activeCaseDetails);
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [UIC, setUIC] = useState(null)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        if(fieldData.trackedEntityAttribute.displayName == "Case Number"){
            validationResult.hideShow = false;
            if(!navigator.onLine){
                values[fieldData.trackedEntityAttribute.id] = "OFFEOAPP";
            }
        }
        if(fieldData.trackedEntityAttribute.displayName == "UIC"){
            validationResult.hideShow = false;
            if(!navigator.onLine){
                validationResult.hideShow = false;
            }
            let uicValue  = validationResult ? validationResult.assign ? validationResult.assign.value : '' : '';
            if(!activeCaseDetails || (activeCaseDetails && !activeCaseDetails.data)){
                try{
                    let townships = JSON.parse(localStorage.getItem("township") || "[]");
                    let selectedTownship = values["VuL6xRU1sew"];
                    if(selectedTownship){
                        let townshipcode = _.filter(townships,{"value":selectedTownship})
                        if(townshipcode && townshipcode.length > 0 && townshipcode[0].code){
                            uicValue = uicValue.replace(townshipcode[0].value,townshipcode[0].code)
                            console.log("uicValue",uicValue)
                        }
                    }
                }catch(e){

                }
                values[fieldData.trackedEntityAttribute.id] = uicValue;
            }
            if(uicValue){
                setUIC(uicValue)
            }
        }
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    
    function getUIC() {
        if(navigator.onLine && UIC == null && fieldData.trackedEntityAttribute.displayName != "UIC"){
            setGlobalSpinner(true)
            apiServices.generateUIC(fieldData.trackedEntityAttribute.id)
            .then(response => {
                setUIC(response.value)
                setGlobalSpinner(false)
            }).catch(err=>{
                setGlobalSpinner(false)
            })
        }else{
            /*OfflineDb.getDataFromPouchDB('offlineUICList').then(res=>{
                let uicobj = res.data.pop();
                setUIC(uicobj.value)
                OfflineDb.setDataIntoPouchDB('offlineUICList', res.data);
            })*/
        }
        
        
    }
    useEffect(() => {
        getUIC()
    }, [linkContactFlag])

    /*return (
        <>
            {UIC != null ?
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={fieldData.trackedEntityAttribute.valueType}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        defaultValue={UIC}
                        disabled={true}
                    />
                </Grid>
                :
                <> </>
            }
        </>
    )*/
        
    useEffect(() => {
        if (validationResult != null && UIC != null) {
            const getMaskedValue = (value) => {
                // if(value==16){
                //     let tempval = value.slice(0, -6) + '      '
                //     console.log(tempval, "tempval")
                //     return tempval;
                // }else {
                //     return value
                // }
                if (value.length <= 6) {
                  return ' '.repeat(value.length);
                }
                else if(value>=10){ 
                  let tempval = value.slice(0, -6) + '      '
                  console.log(tempval, "tempval")
                  return tempval;
                }
        
              };
            //console.log("UIC ",UIC);
            //values[fieldData.trackedEntityAttribute.id] = UIC;
            {}
            
            console.log("UIC>>>",UIC,values[fieldData.trackedEntityAttribute.id])
            
            setFieldStructure(
                <>
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                  {}
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={fieldData.trackedEntityAttribute.valueType}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        defaultValue={UIC}
                        //{UIC ? getMaskedValue(UIC) : UIC}
                        initialValue = {values[fieldData.trackedEntityAttribute.id]}
                        //{values[fieldData.trackedEntityAttribute.id] ? getMaskedValue(values[fieldData.trackedEntityAttribute.id]) : values[fieldData.trackedEntityAttribute.id]}
                        disabled={true}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={4} className={ UIC >= 6 ? 'hide' : ''}>
                <TextField
                    id='uicc'
                    label={"UIC "}
                    value = {values[fieldData.trackedEntityAttribute.id] ? values[fieldData.trackedEntityAttribute.id].slice(0, -6) + '      ' : values[fieldData.trackedEntityAttribute.id]}
                    disabled={true}
                />
                </Grid>
            </>
            )
        }

    }, [validationResult,UIC,localStorage.getItem("locale")])
    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>
            }
        </>
    )
}

function BooleanFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    const switchData = [
        { label: 'Yes', value: 'item1' },
    ];

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Switches
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        name={fieldData.trackedEntityAttribute.id}
                        disableRipple
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        data={switchData}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let showYear = fieldData.trackedEntityAttribute.attributeValues.length > 0 && fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <TimePicker
                        label={fieldData.trackedEntityAttribute.displayFormName}
                        name={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        margin="normal"
                        variant="inline"
                        format="HH:MM"
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function IntegerConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let programData = props.programData
    let values = props.values
    const {t} = useTranslation()
    const [optionSet, setOptions] = useState(null)
    const [ageId, setAgeID] = useState(null)
    function getCustomVariableIds(){
        programData.programTrackedEntityAttributes.map(regField => {
            if(regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "age"){
                setAgeID(regField.trackedEntityAttribute.id)
            }
        })
    }

    const requiredOptions = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Please fill out this field') : undefined)
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? t('Must be a number') : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : t('Should be greater than')+min

    const maxValue = max => value =>
        isNaN(value) || value <= max ? undefined : t('Should be less than')+max


    const errorCheck = value => (value ? findError(value): undefined)
    
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function calculateAge(selectedDate) {
        let dt2 = new Date(selectedDate);
        let dt1 = new Date();
    
        var a = moment(dt2);
        var b = moment(dt1);
    
        var years = a.diff(b, "years");
        var birth = Math.abs(years);
        var age = Math.abs(years);
        console.log("years", age);
        return age;
      }

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult) 
        if(fieldData.trackedEntityAttribute.displayName && fieldData.trackedEntityAttribute.displayName.toLowerCase() == "year of birth" && fieldData.trackedEntityAttribute.optionSet && fieldData.trackedEntityAttribute.optionSet.options){
            let output = []
            fieldData.trackedEntityAttribute.optionSet.options.map((items, index) => {    
                output.push({ 'value': items.code, 'label': getTranslatedLabels(items) })
            })
            fieldData.mandatory = true
            setOptions(output)
        }       
    }

    function findError (value) {
        let latestValidationValue = {}
        latestValidationValue[fieldData.trackedEntityAttribute.id] = value

        let fetchValidationDetails = Validator(fieldData.trackedEntityAttribute.id, fieldData, latestValidationValue, programRules, programRulesVariables)
        return fetchValidationDetails.showError ? fetchValidationDetails.showError : undefined
    }

    useEffect(() => {
        getCustomVariableIds()
    }, [])

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            if(fieldData.trackedEntityAttribute.displayName && fieldData.trackedEntityAttribute.displayName.toLowerCase() == "year of birth"){
                if(values && values[fieldData.trackedEntityAttribute.id]){
                    if(values[fieldData.trackedEntityAttribute.id] >= 1900 && values[fieldData.trackedEntityAttribute.id] < 1960){
                        values[fieldData.trackedEntityAttribute.id] = "1960"
                    }
                    try{
                        values[ageId] = (moment().year()) - (values[fieldData.trackedEntityAttribute.id])
                    }catch(e){
                        console.log(e);
                    }
                    
                }
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} >
                        <Field
                            id={fieldData.trackedEntityAttribute.id}
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            // type={fieldData.trackedEntityAttribute.valueType}

                            component={SingleSelectFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            //validate= {fieldData.mandatory && validationResult.hideShow == true ? hasValue: false}
                            validate= {composeValidators(requiredOptions)}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            options={optionSet != null ? optionSet : []}
                            disabled={fieldData.trackedEntityAttribute.attributeValues && fieldData.trackedEntityAttribute.attributeValues.length > 0 ? fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                            //onChange={() => onDropdownOptionChange}
                        />
                    </Grid>
                )
            }else{
                if(fieldData.trackedEntityAttribute.id == ageId){
                    validationResult.hideShow = false
                }
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber, minValue(1), errorCheck)}
                        value=''
                    />
                </Grid>
            )
            }
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TextAreaConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    const {t} = useTranslation()
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const scriptCheck = value => (value ? value.match(/<[^>]*>/g) != null ? t('Incorrect expression "< or >" added as input') : undefined : undefined)
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'text'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, scriptCheck)}
                        autoGrow
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function UserNameConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? 'hide' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        component={TextAreaFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        //validate={composeValidators(hasValue, dhis2Username)}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function URLConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    const {t} = useTranslation()
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)

    const URLCheck = value => (regexp.test(value) ? undefined : t('Incorrect URL format'))

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        component={TextAreaFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, URLCheck)}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function HandleOUOptions(props) {
    //console.log("props1244",props)
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let OUMappingList = OUMapping(values)   
    let parentValue = OUMappingList[fieldData.trackedEntityAttribute.id] != undefined ? values[OUMappingList[fieldData.trackedEntityAttribute.id].parent] : null
    let programData = props.programData
    let options= props.options
    let defaultOption= props.defaultOption
    let fieldRequired = props.fieldRequired
    let stateData = props.stateList
    let townshipData = props.townshipList
    let rules = {
       "programRule": props.programRules,
       "programRuleVariable":props.programRulesVariables
    }
    let OUJSON = props.OUJSON.organisationUnits
    if(fieldData.trackedEntityAttribute.displayName == "Facility address"){
        OUJSON = OUJSON.filter(obj => obj.comment == "Facility")
    }

    const option = { "id": "option1", "label": 'Option1', "value": 'option1' }

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [location, setLocation] = useState([])
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [sessionUserBoValue, setSessionUserBoValue] = useState(null)

    async function getMetaData() {
        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        //console.log("loginDetails",loginDetails)
        setSessionUserBoValue(loginDetails.data)
    }
    useEffect(() => {
        getMetaData();
    }, [])

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        if(options != '') {
            let locationList = []
            //setGlobalSpinner(true)
            if(options != '' && fieldData.trackedEntityAttribute.displayName != "District"){
                let locationList = []
                let OUResponse = townshipData;
                let OUAPI = apiServices.getAPI('29/organisationUnits/' + options + '?paging=false&fields=children[id,displayName,children::isNotEmpty,path]')
                if(fieldData.trackedEntityAttribute.displayName == "Township Of Birth"){
                    //OUAPI = apiServices.postAPI('bulk/orgnisation/gettownship', {"orguid":values["DskbnoxcNC6"]})
                }
                //apiServices.getAPI('organisationUnits/' + options + '?paging=false&fields=children[id,displayName,children::isNotEmpty,path]')
                if(values && values["DskbnoxcNC6"] && fieldData.trackedEntityAttribute.displayName == "Township Of Birth" && OUResponse.data && OUResponse.data.data){
                    
                    OUResponse = _.filter(OUResponse.data.data,{stateuid:values["DskbnoxcNC6"]})
                    // setGlobalSpinner(true)
                    // //apiServices.postAPI('bulk/orgnisation/gettownship', {"orguid":values["DskbnoxcNC6"]})
                    // OUAPI
                    // .then(OUResponse => {
                        if(OUResponse && OUResponse.length > 0) {
                            OUResponse.map(locations => {
                                let obj = {
                                    'id': locations.townuid,
                                    'label': localStorage.getItem("locale") && localStorage.getItem("locale") == 'my' && locations.translations ? locations.translations : locations.townname,
                                    'value': locations.townuid,
                                    'code': locations.towncode ? locations.towncode : null
                                }
                                locationList.push(obj)
                                locationList = _.orderBy(locationList, ['label'],['asc'])
                                setLocation(locationList)
                                setGlobalSpinner(false)
                                if(fieldData.trackedEntityAttribute.displayName == "Township Of Birth"){
                                    localStorage.setItem('township',JSON.stringify(locationList))
                                }
                            })
                        }else{
                            setGlobalSpinner(false)
                        }
                        
                    // }).catch(err=>{
                    //     setGlobalSpinner(false)
                        
                    // })
                }
            }
            /*const filterOnId = OUJSON.filter(obj => obj.id == options)
            if(filterOnId.length > 0 && fieldData.trackedEntityAttribute.displayName != "Facility address") {
                const childrenOptions = filterOnId[0].children
                childrenOptions.map(childOptions => {
                    const filterChildDetails = OUJSON.filter(obj => obj.id == childOptions.id)
                    if(filterChildDetails.length > 0) {
                        let obj = {
                            'id': filterChildDetails[0].id,
                            'label': filterChildDetails[0].name,
                            'value': filterChildDetails[0].id,
                        }
                        locationList.push(obj)
                        setLocation(locationList)
                    }
                    
                })
                
            }*/
            if(fieldData.trackedEntityAttribute.displayName == "Facility address"){
                OUJSON.map(facility=>{
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    locationList.push(obj)
                    locationList = _.orderBy(locationList, ['label'],['asc'])
                    setLocation(locationList)
                })
            }
        } else {
            const OUList = programData.organisationUnits
            let autocompleteData = []
            if (OUMappingList[fieldData.trackedEntityAttribute.id] != undefined && fieldData.trackedEntityAttribute.displayName != "Facility address") {
                if (OUMappingList[fieldData.trackedEntityAttribute.id].type) {
                    
                    //let OUOptions = OUJSON.filter(obj => obj.level == OUMappingList[fieldData.trackedEntityAttribute.id].level)
                    let ouResponse = stateData;
                    // apiServices.postAPI('bulk/orgnisation/getstate', {})
                    // .then(ouResponse => {
                        const fetchOUOptions = ouResponse.data.children
                        const OUOptions = fetchOUOptions;
                        if(OUOptions.length > 0) {
                            OUOptions.map(items => {
                                let obj = {
                                    'id': items.id , 
                                    'label': localStorage.getItem("locale") && localStorage.getItem("locale") == 'my' && items.translation ? items.translation : items.displayName, 
                                    'value': items.id
                                }
                                autocompleteData.push(obj)
                            })
                            autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                            setLocation(autocompleteData)
                        }
                    //})
                }
            }
            if(fieldData.trackedEntityAttribute.displayName == "Facility address"){
                OUJSON.map(facility=>{
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    autocompleteData.push(obj)
                    autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                    setLocation(autocompleteData)
                })
            }
            if(fieldData.trackedEntityAttribute.displayName == "Hotspots"){
                let OUResponse = sessionUserBoValue ? sessionUserBoValue.organisationUnits ? _.filter(sessionUserBoValue.organisationUnits,{"level":6}) : [] : [];
                if(OUResponse && OUResponse.length == 0){
                    //OUResponse = OUJSON ? _.filter(OUJSON,{"level":6}) : null;
                }
                    if(OUResponse && OUResponse.length > 0){
                        //OUResponse = _.filter(OUResponse,{"level":6})
                        OUResponse.map(facility=>{
                            let obj = {
                                'id': facility["id"],
                                'label': facility["displayName"],
                                'value': facility["id"],
                            }
                            autocompleteData.push(obj)
                            autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                            setLocation(autocompleteData)
                        })
                    }
            }

        }
        
    }, [values[fieldData.trackedEntityAttribute.id], parentValue, options,sessionUserBoValue,localStorage.getItem("locale")]) //defaultOption, options

    useEffect(() => {
            if(location != null) {
                if(values[fieldData.trackedEntityAttribute.id]) {
                    if(!_.isEmpty(defaultOption)) {
                        setFieldStructure(
                            <OUFieldConfig 
                                data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList} OUMandatory={fieldRequired}
                            />
                        )
                    }
                }else {
                    setFieldStructure(
                        <OUFieldConfig 
                            data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList} OUMandatory={fieldRequired}
                        />
                    )
                }
            }
            
        
    }, [location,localStorage.getItem("locale")])
    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function MultiSelectConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let DataElementGroup = DataElementGroup
    let programObj = programObj

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    function getFieldDetails(fieldId, formValues) {
        const getFieldsAttributes = programObj.programTrackedEntityAttributes.filter(
            (obj) => obj.trackedEntityAttribute.id == fieldId
        );

        if (getFieldsAttributes.length > 0) {

            const fieldData1 = getFieldsAttributes[0];

            const findField = HideCheckboxOptions[fieldData1.trackedEntityAttribute.id]
            let isFieldDisbaled = false
            if (findField != undefined) {
                
                findField.field.map(eachField => {
                    if (formValues[eachField] == findField.value) {
                        isFieldDisbaled = true
                    }
                })


            }


            return (
                <Field
                    type="checkbox"
                    component={CheckboxFieldFF}
                    name={this.props.DataElementGroup.id}
                    disabled={isFieldDisbaled}
                    label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                    value={fieldData1.trackedEntityAttribute.id}
                />
            );
        }
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} className={validationResult.hideShow == true ? 'customLoc' : 'hide'}>
                    <FieldGroupFF
                        label={DataElementGroup.displayName}
                        // onClick={(e, v) => onChange(e, v)}
                        name={DataElementGroup.id}
                    >
                        {DataElementGroup.trackedEntityAttributes.map((field) => {
                            return getFieldDetails(field.id, values);
                        })}
                    </FieldGroupFF>
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function QrCodeScanner(props) {
    const {t} = useTranslation()
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let activeCaseDetails = props.activeCaseDetails
    let userBO = props.userBO
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [fieldStructure, setFieldStructure] = useState(null)
    const [showScannner, setShowScannner] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    let QRdata = ""
    //const [QRdata, setQRData] = useState('No result');

    function generateQRCode(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return "dureProg_"+result;
    }

    function qrErrorhandler(data) {
        setShowScannner(false)
    }

    function handleQRScan(result, error) {
        if(QRdata){
        console.log("data ",QRdata, navigator.onLine)
        try{
            if (QRdata && QRdata.startsWith('dureProg_')) {
                if(navigator.onLine){
                    setGlobalSpinner(true)
                    //call api here to check qr is available or not
                    let orgID = userBO.organisationUnits[0].id, //`UuYrI1twhmN`,
                    programID = userBO.programs[0], //`nSy7PFqQykt`,
                    searchQuery = `&attribute=${fieldData.trackedEntityAttribute.id}:LIKE:${QRdata}`
                    let subURL = "trackedEntityInstances/query.json?ouMode=ALL&&order=created:desc&program=" + programID + searchQuery +"&pageSize=50&page=1&totalPages=false&skipPaging=true";
                    apiServices.getAPI(subURL)
                    .then(res => {
                        if(res && res.data && res.data.rows && res.data.rows.length == 0){
                            setDefaultValue(QRdata)
                            swal({
                                title: t("Success"),
                                text: t("QR code attached successfully"),
                                icon: "info",
                                button: t("Ok"),
                            });
                        }else{
                            if(res && res.data && res.data.rows && res.data.rows.length > 0){
                                swal({
                                    title: t("Alert"),
                                    text: t("This QR code has already been assigned to an existing client. Please use another QR code"),
                                    icon: "info",
                                    button: t("Ok"),
                                });
                            }else{
                                swal({
                                    title: t("Error"),
                                    text: t("Sorry, something went wrong."),
                                    icon: "info",
                                    button: t("Ok"),
                                });
                            }
                        }
                        setGlobalSpinner(false)
                    }).catch(err => {
                        setGlobalSpinner(false)
                    })
                }else{
                    setGlobalSpinner(true)
                    //for offline
                    let qrExist = false
                    OfflineDb.getAllEntities().then(res => {
                        if (res && res.total_rows && res.total_rows > 0) {
                            res.rows.map(entityObj => {
                                if(!qrExist && entityObj.doc.data && entityObj.doc.data[fieldData.trackedEntityAttribute.id] && entityObj.doc.data[fieldData.trackedEntityAttribute.id] == QRdata){
                                    qrExist = true;
                                    swal({
                                        title: t("Alert"),
                                        text: t("This QR code has already been assigned to an existing client. Please use another QR code"),
                                        icon: "info",
                                        button: t("Ok"),
                                    });
                                    return;
                                }
                            })
                            setGlobalSpinner(false)
                            if(!qrExist){
                                setDefaultValue(QRdata)
                                swal({
                                    title: t("Success"),
                                    text: t("QR code attached successfully"),
                                    icon: "info",
                                    button: t("Ok"),
                                });
                            }
                        }else{
                            setGlobalSpinner(false)
                            setDefaultValue(QRdata)
                            swal({
                                title: t("Success"),
                                text: t("QR code attached successfully"),
                                icon: "info",
                                button: t("Ok"),
                            });
                        }
                    })
                }
            }else{
                swal({
                    title: t("Alert"),
                    text: t("QR code is not valid"),
                    icon: "info",
                    button: t("Ok"),
                  });
            }
        }catch(e){
            swal({
                title: t("Alert"),
                text: t("QR code is not valid"),
                icon: "info",
                button: t("Ok"),
              });
        }
        setShowScannner(false)
    }
    }

    function closeQrSacnner() {
        setShowScannner(false)
    }
    function openCordovaQrScanner (){
        let that = this;
        window.cordova.plugins.barcodeScanner.scan(
            function (result) {
                QRdata = result.text
                handleQRScan(result.text);
            },
            function (error) {
                
            },
            {
                preferFrontCamera: false, // iOS and Android
                showFlipCameraButton: true, // iOS and Android
                showTorchButton: false, // iOS and Android
                torchOn: false, // Android, launch with the torch switched on (if available)
                prompt: 'Place a barcode inside the scan area', // Android
                resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                disableAnimations: true, // iOS
                disableSuccessBeep: false // iOS
            }
         );    
    }
    function openQrSacnner () {
        if(window.cordova){
            openCordovaQrScanner()
        }else{
            setShowScannner(true)
        }
    }
    
    useEffect(() => {
        //console.log("defaultValue ",defaultValue,activeCaseDetails)
        if(defaultValue!=null){
            values[fieldData.trackedEntityAttribute.id] = defaultValue
        }
        if(showScannner) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={fieldData.trackedEntityAttribute.valueType}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                    <div>
                        <QrReader
                            delay={300}
                            onError={qrErrorhandler}
                            onScan={(result, error) => {
                                QRdata = result
                                console.log("result",result)
                                handleQRScan();
                                setTimeout(() => {
                                    console.log("Time out")
                                    closeQrSacnner()
                                }, 5000);
                              }}
                            style={{ width: '50%', cursor: 'pointer' }}
                        />
                        {/* <span onClick={() =>closeQrSacnner()}><FontAwesomeIcon icon={faTimes} /></span> */}
                    </div>
                </Grid>
            )
        } else {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={fieldData.trackedEntityAttribute.valueType}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                    <p 
                        className={
                        // values[fieldData.trackedEntityAttribute.id] && 
                        // activeCaseDetails && activeCaseDetails.data && 
                        // !activeCaseDetails.data.hasOwnProperty("offlineRescanQr") ? "hide" : 
                        "qrIcon"} 
                        onClick={() => openQrSacnner()}>
                            <FontAwesomeIcon className="fa-3x" style={{color:values[fieldData.trackedEntityAttribute.id] ? '#0468b1' : 'black'}} 
                            icon={faQrcode} />
                        <p 
                         // style={{padding: "15px"}}
                        className={
                        values[fieldData.trackedEntityAttribute.id] && 
                        activeCaseDetails && activeCaseDetails.data && 
                        !activeCaseDetails.data.hasOwnProperty("offlineRescanQr") ? "qrIcon" : 
                        "hide"} 
                        onClick={() => openQrSacnner()}
                        style={{textDecoration: "underline", fontSize: "11px", cursor: "pointer"}}>
                       {/* <p style={{textDecoration: "underline", fontSize: "11px"}}> */}
                        {t("Replace QR code")}</p> 
                        {/* </p>       */}
                    </p>

                    {/* {
                    values && values[fieldData.trackedEntityAttribute.id] ?
                    <div>
                        <QRCodeSVG
                        id="qr-gen"
                        value={values[fieldData.trackedEntityAttribute.id]}
                        size={50}
                        level={"H"}
                        includeMargin={true}
                        //onClick={enlargeImg}
                        />
                    </div>
                       : <></>
                    } */}
                </Grid>
            )
        }
    }, [showScannner,defaultValue,localStorage.getItem("locale")])


    return (
        <>
            {
                fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function ImageFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [defaultValue, setDefaultValue] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    async function openFileChooser(){
        console.log("openFileChooser")
        const file = await window.chooser.getFile();
        console.log(file);
        setDefaultValue(file)
    }
    useEffect(() => {
        
        if (validationResult != null) {
            if(window.cordova && !navigator.onLine){
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        <div style={{ display: 'none' }}>
                            <Field
                                name={fieldData.trackedEntityAttribute.id}
                                label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                                type={fieldData.trackedEntityAttribute.valueType}
                                component={InputFieldFF}
                                key={fieldData.trackedEntityAttribute.id}
                                defaultValue={defaultValue}
                            />
                        </div>
                        <label>{getTranslatedLabels(fieldData.trackedEntityAttribute)}</label>
                        <p className="qrIcon" onClick={() => openFileChooser()}><FontAwesomeIcon className="fa-3x" icon={faFileUpload} /></p>
    
                    </Grid>
                    
                )
            }else{
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        {/* <DropzoneArea
                            name={fieldData.trackedEntityAttribute.id}
                            onChange={handleChange.bind(this)}
                            filesLimit={1}
                        /> */}
    
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            component={FileInputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            value={[]}
                            //onChange={handleChange.bind(this)}
                            //validate={composeValidators(required, URLCheck)}
                        />
    
                    </Grid>
                )
            }
            
        }

    }, [validationResult,defaultValue,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function GoogleLocation(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    const {t} = useTranslation()
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [placeholder, setPlaceholder] = useState(values[fieldData.trackedEntityAttribute.id] ? values[fieldData.trackedEntityAttribute.id] : null)
    //const [value, setValue] = useState('INDIA')

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    const noOptionsMessage = (value) => {
        values[fieldData.trackedEntityAttribute.id] = value.inputValue
        setPlaceholder(value.inputValue)
    }

    const onChnage = (value) => {
    console.log('onchange', value)
    Geocode.setApiKey('AIzaSyC1i55hHwdQFdwU1BxXjJpaq7QVqqQjSMg')
    values[fieldData.trackedEntityAttribute.id] = value.label
                            setPlaceholder(value.label)
    geocodeByAddress(value.label)   
        .then(results => getLatLng(results[0]))
        .then(({ lat, lng }) => {
            //setValue(value.label)
            let fieldId = fieldData.trackedEntityAttribute.id
            values[fieldId] = value.label
            let lati = ''
            let lngi = ''
            Geocode.fromAddress(value.label).then(
                response => {
                    const { lat, lng } = response.results[0].geometry.location;
                    lati = lat
                    lngi = lng
                    
                    

                    Geocode.fromLatLng(lat, lng).then(
                        response => {
                            const address = response.results[0].formatted_address;
                            
                            
                            
                            const data = {
                                'value': value,
                                'fieldId': fieldData.trackedEntityAttribute.id,
                                'lat': lat,
                                'lng': lng,
                            }
                            props.onGoogleLocationChange(data) 
                        },
                        error => {
                            console.error(error);
                        }
                    );
                },
                error => {
                    console.error(error);
                }
            );


        }


        );
    }

    useEffect(() => {
        fetchValidation()
    }, [values, placeholder])

    useEffect(() => {
        if (validationResult != null) {
            if(navigator.onLine){

                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? 'customLoc' : 'hide'}>
                        <div>
                        <label>{getTranslatedLabels(fieldData.trackedEntityAttribute)} </label>
                        <GooglePlacesAutocomplete
                            name={fieldData.trackedEntityAttribute.id}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required)}
                            apiKey={'AIzaSyC1i55hHwdQFdwU1BxXjJpaq7QVqqQjSMg'}
                            autocompletionRequest={{
                                bounds: [
                                    { lat: 50, lng: 50 },
                                    { lat: 100, lng: 100 }
                                ],

                            }}
                            selectProps={{
                                placeholder: placeholder != null ? placeholder : '',
                                //value,
                                onChange: (value) => onChnage(value),
                                noOptionsMessage: (value) => noOptionsMessage(value)
                            }}
                        />
                        </div>
                    </Grid>
                )
            }else{
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true? 'customLoc' : 'hide'}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required)} //fieldData.mandatory && validationResult.hideShow == true ? hasValue : false
                        />
                    </Grid>
                )
            }
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function CreateField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let programData = props.programData
    let activeCaseDetails = props.activeCaseDetails
    let linkContactFlag = props.linkContactFlag
    let userBO = props.sessionUserBo
    let OUM = OUMapping(values)
    let OUJSON = props.OUJSON
    let Configuration=props.Configuration
    let customfieldobj = props.customfieldobj;
    //const OUM = OUMapping(values)
    let sessionUserBoValue = props.sessionUserBo

    
    let rules = {
        "programRule": props.programRules,
        "programRuleVariable":props.programRulesVariables
     }

     


    function checkFieldType() {
        const onGoogleLocatioChange = (value) => {
            props.onGoogleLocatioChangeParent(value)
        }
        if(fieldData.trackedEntityAttribute.displayName && fieldData.trackedEntityAttribute.displayName.toLowerCase() == "year of birth"){
            //console.log("year of birth ",fieldData.trackedEntityAttribute)
            //fieldData.trackedEntityAttribute.valueType = 'TEXT'
            let yearOptions = [];
            const d = new Date();
            let currentYear = d.getFullYear();
            for(var i=1960;i<=currentYear;i++){
                yearOptions.push({
                    "code": i.toString(),
                    "id": i.toString(),
                    "displayName": i.toString(),
                    "style": {},
                    "translations": []
                  });
            }
            fieldData.trackedEntityAttribute.optionSet = {
                id:"yeraid",
                options:yearOptions
            }
        }
        if(fieldData.trackedEntityAttribute.displayName && fieldData.trackedEntityAttribute.displayName.toLowerCase() == "uic"){
            fieldData.trackedEntityAttribute.unique = true;
        }
        switch (fieldData.trackedEntityAttribute.valueType) {
            case 'TEXT':
                return fieldData.trackedEntityAttribute.unique
                    ?
                    <DefaultValueField
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        linkContactFlag={linkContactFlag}
                        activeCaseDetails={activeCaseDetails}
                        OUMapping ={OUM}
                        OUJSON = {OUJSON}
                    />
                    :
                    fieldData.renderType && fieldData.renderType['DESKTOP'] && fieldData.renderType['DESKTOP'].type == "QR_CODE" ?
                    <QrCodeScanner
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        //customClassName={customClassName}
                        activeCaseDetails={activeCaseDetails}
                        userBO={userBO}
                    />

                    :
                    fieldData.trackedEntityAttribute.attributeValues 
                        ? fieldData.trackedEntityAttribute.attributeValues[0] 
                            ? fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == 'enableGoogleLocation'
                                ?
                                    <GoogleLocation
                                        fieldData={fieldData}
                                        programRules={programRules}
                                        programRulesVariables={programRulesVariables}
                                        values={values}
                                        linkContactFlag={linkContactFlag}
                                        onGoogleLocationChange = {onGoogleLocatioChange}
                                        customfieldobj={customfieldobj}
                                        
                                    />
                                :
                                <InputFieldConfig
                                    fieldData={fieldData}
                                    programRules={programRules}
                                    programRulesVariables={programRulesVariables}
                                    values={values}
                                    programData={programData}
                                    activeCaseDetails={activeCaseDetails}
                                    linkContactFlag={linkContactFlag}
                                    Configuration={Configuration}
                                    customfieldobj={customfieldobj}
                                    
                                />
                            :
                            <InputFieldConfig
                                fieldData={fieldData}
                                programRules={programRules}
                                programRulesVariables={programRulesVariables}
                                values={values}
                                programData={programData}
                                activeCaseDetails={activeCaseDetails}
                                linkContactFlag={linkContactFlag}
                                Configuration={Configuration}
                                customfieldobj={customfieldobj}
                            />    
                            
                    : <InputFieldConfig
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        programData={programData}
                        activeCaseDetails={activeCaseDetails}
                        linkContactFlag={linkContactFlag}
                        Configuration={Configuration}
                        customfieldobj={customfieldobj}
                    />
                    //case 'COORDINATE':
                        // return <GoogleLocation
                        //     fieldData={fieldData}
                        //     programRules={programRules}
                        //     programRulesVariables={programRulesVariables}
                        //     values={values}
                        //     linkContactFlag={linkContactFlag}
                        // />
            case 'IMAGE':            

            case "FILE_RESOURCE":
                return <ImageFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    
                />


            case 'DATE':
                return <DateFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'AGE':
                return <AgeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'PHONE_NUMBER':
                return <PhoneNumberFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'EMAIL':
                return <EmailFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />
            case 'BOOLEAN':

                if (programData.programSections.length > 0 &&
                    programData.programSections.filter(
                        (obj) => obj.displayName == fieldData.trackedEntityAttribute.displayName
                    ).length > 0
                ) {
                    const filterDataElementGroup = programData.programSections.filter(
                        (obj) => obj.displayName == fieldData.trackedEntityAttribute.displayName
                    )[0];

                    return (
                        <MultiSelectConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            DataElementGroup={filterDataElementGroup}
                            programObj={programData}
                        />
                    );
                } else {
                    return <BooleanFieldConfig
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                    />
                }
            case 'TRUE_ONLY':
                return <BooleanFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />
            case 'TIME':
                return <TimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'DATETIME':
                return <DateTimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'INTEGER':
            case 'INTEGER_POSITIVE':
            case 'INTEGER_NEGATIVE':
            case 'INTEGER_ZERO_OR_POSITIVE':
            case 'NUMBER':
                return <IntegerConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    programData={programData}
                />
            case 'LONG_TEXT':
                return <TextAreaConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'USERNAME':
                return <UserNameConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'URL':
                return <URLConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'ORGANISATION_UNIT':
                const defaultValue = values[fieldData.trackedEntityAttribute.id]
                
                let optionsId = ''
                let defaultOption = {}
                const childDropDown = JSON.parse(localStorage.getItem('childDropDown'))
                    if (childDropDown != null) {
                        const fieldOptionFilter = childDropDown.filter(obj => obj.fieldId == fieldData.trackedEntityAttribute.id)
                        if (fieldOptionFilter.length > 0) {
                            optionsId = fieldOptionFilter[0].value
                        }

                    }
                if (defaultValue != undefined) {
                    
                    let LocationFilter = []
                    if(fieldData.trackedEntityAttribute.displayName == "Hotspots"){
                        let OUResponse = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits : [] : [];
                        LocationFilter = OUResponse.filter(OU => OU.id == values[fieldData.trackedEntityAttribute.id])
                        if(LocationFilter && LocationFilter.length == 0 && OUJSON && OUJSON.organisationUnits && OUJSON.organisationUnits.length > 0){
                            LocationFilter = OUJSON.organisationUnits.filter(OU => OU.id == values[fieldData.trackedEntityAttribute.id])
                        }
                    }else{
                        LocationFilter = OUJSON.organisationUnits.filter(OU => OU.id == values[fieldData.trackedEntityAttribute.id])
                    }
                    //const LocationFilter = programData.organisationUnits.filter(OU => OU.id == values[fieldData.trackedEntityAttribute.id])
                    let locationName = LocationFilter.length > 0 ? localStorage.getItem("locale") && localStorage.getItem("locale") == 'my' && LocationFilter[0].translations && LocationFilter[0].translations.length > 0 ? LocationFilter[0].translations[0].value : LocationFilter[0].displayName : ""
                    defaultOption = {
                        'id': values[fieldData.trackedEntityAttribute.id],
                        'label': locationName ? locationName : values[fieldData.trackedEntityAttribute.id],
                        'value': values[fieldData.trackedEntityAttribute.id]
                    }

                    if (OUM[fieldData.trackedEntityAttribute.id] != undefined) {
                        if (OUM[fieldData.trackedEntityAttribute.id].parent != '') {
                            optionsId = values[OUM[fieldData.trackedEntityAttribute.id].parent]
                        }
                    }
                    
                }
                let fieldMandatory = false;
                if(fieldData.trackedEntityAttribute.displayName == "Township Of Birth" || fieldData.trackedEntityAttribute.displayName == "Hotspots"){
                    fieldMandatory = true;
                }
                 //LocationFilter, locationName optionsId, defaultValue,
                //if(optionsId != '') {
                if(fieldData.trackedEntityAttribute.displayName != "District")
                    return <HandleOUOptions
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    programData={programData}
                    options={optionsId} 
                    defaultOption={defaultOption}
                    OUMapping ={OUM}
                    OUJSON = {OUJSON}
                    fieldRequired = {fieldMandatory}
                    stateList={props.stateList}
                    townshipList={props.townshipList}
                    />
                 

        }
    }


    return (
        <>
            {checkFieldType()}
        </>

    )
}

export default CreateField;
